import React, { useState } from 'react'
import { Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { HorizontalStackedBarChart } from '../../../charts/BarChart'
import { ATTEMPT_COLORS } from '../../../charts/colors'
import MaterialTable from '../../../../common/MaterialTable'
import useGetCourier from '../useGetCourier'
import _ from 'lodash'

const attemptBuckets = ['0_Attempts', '1_Attempts', '2_Attempts', '3_Attempts', 'moreThan3Attempts']
const attemptLabels = { '0_Attempts': '0 Attempts', '1_Attempts': '1 Attempt', '2_Attempts': '2 Attempts', '3_Attempts': '3 Attempts', 'moreThan3Attempts': '3+ Attempts' }
const attemptColors = ATTEMPT_COLORS

const DeliveryAttemptAnalysis = ({ data = [], title = 'Courier Wise Delivery Attempt Breakdown' }) => {
    const [view, setView] = useState('chart')
    const { data: allCouriers } = useGetCourier()

    if (!data || data.length === 0) return null

    const enrichedData = data.map(row => {
        const courier = _.find(allCouriers, { id: row.name })
        return { ...row, name: courier ? courier.parent : row.name }
    })

    const chartOptions = {
        yaxis: 'name',
        data: attemptBuckets.map((b, i) => ({
            dataKey: `${b}_perc`,
            label: attemptLabels[b],
            fill: attemptColors[i],
        })),
        stackId: 'a',
        showLabels: true,
        legendAlign: 'left',
    }

    const columns = [
        { label: 'Courier', value: 'name', align: 'left' },
        ...attemptBuckets.map(b => ({
            label: attemptLabels[b],
            value: (row) => `${row[b]} (${row[`${b}_perc`]}%)`,
        })),
        { label: 'Total', value: 'total' },
    ]

    return (
        <Card elevation={1}>
            <CardHeader
                title={title}
                subheader="Breakdown of RTO shipments by number of delivery attempts made before RTO"
                action={
                    <ToggleButtonGroup value={view} exclusive size="small" onChange={(_e, v) => v && setView(v)}>
                        <ToggleButton value="chart">Chart</ToggleButton>
                        <ToggleButton value="table">Table</ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            <CardContent>
                {view === 'chart' ? (
                    <HorizontalStackedBarChart data={enrichedData} chartOptions={chartOptions} height={Math.max(250, enrichedData.length * 35 + 80)} />
                ) : (
                    <MaterialTable columns={columns} rows={enrichedData} />
                )}
            </CardContent>
        </Card>
    )
}

export default DeliveryAttemptAnalysis
